module.exports = __webpack_public_path__ + "static/media/Inter-LightItalic-BETA.faed8782.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-LightItalic-BETA.woff
// module id = 695
// module chunks = 21